























































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ProductCard1 extends Vue {
  @Prop({ type: Object }) readonly product!: object;
  @Prop({ type: Boolean, default: false }) readonly inOffcanvas!: boolean;

  private readonly MAX_COMPARE_ITEMS: number = 3;

  public gotoLink (location: string): void {
    window.location.href = location
  }

  public addToCompare (productId: string): void {
    (window as any).addToCompare(productId)
  }
}
